import request from "../../Requests/requests";
import { activateTimer } from "../../store/RunTimeTaskResults/RunTimeResults";

export const findActiveTimer = () => {
    return async dispatch => {
        try {
            const response = await request.get('/Timer', { params: {
                UserId: localStorage.getItem('userID')
            }});
            const data = response.data
            .then(response => response.data)
            .then(data => dispatch(activateTimer({isTimerActive: true, taskId: data.taskId, startTime: data.startTime})))
            return data
        } catch (error) {
            return error;
        }
        
        
    }
}